<template>
  <div class="category-id">
    <div v-if="pageLoading" class="text-center">
      <looping-rhombuses-spinner
        :animation-duration="2500"
        :rhombus-size="15"
        color="#EF6C00"
        class="mx-auto my-10"
      />
    </div>
    <v-card v-else class="common-card grey lighten-4">
      <div>
        <span class="fs-xlarge shopPrimary--text">دسته‌بندی:</span>
        <span class="fs-xlarge ms-2">{{ categoryInfo.name }}</span>
      </div>
      <div class="mt-6">
        <span class="shopPrimary--text fs-small">توضیحات:</span>
        <span class="ms-2 fs-small">{{
          categoryInfo.description ? categoryInfo.description : "-"
        }}</span>
      </div>

      <div class="products mt-16 d-flex flex-wrap flex-row">
        <span v-show="false">{{ reactivity }}</span>
        <v-row>
          <v-col
            v-for="(item, index) in categoryProducts"
            :key="index"
            lg="2"
            md="3"
            sm="4"
            cols="12"
            class="text-center"
          >
            <div
              class="product-item d-flex flex-column mx-auto pointer"
              @click="
                $router.push(
                  `/productDetails/${item.name.replaceAll(' ', '-')}-${item.id}`
                )
              "
            >
              <div class="product-image">
                <img
                  :src="item.pictureUrl ? item.pictureUrl : '/no-image.png'"
                />
                <!-- Add product to cart button -->
                <div v-if="!item.sum" class="operation error--text">
                  <b
                    ><v-icon color="error" class="me-1">mdi-close-circle</v-icon
                    >ناموجود</b
                  >
                </div>
                <div v-else>
                  <v-btn
                    v-if="!isInCart(item)"
                    @click.stop="addToCart(item, index)"
                    class="add-btn operation shopPrimary"
                    small
                    :loading="addLoading[index]"
                  >
                    <template v-slot:loader>
                      <div>
                        <half-circle-spinner
                          :animation-duration="1000"
                          :size="20"
                          color="#fff"
                        />
                      </div>
                    </template>
                    <v-icon color="#fff">mdi-plus</v-icon></v-btn
                  >

                  <ProductCounter
                    class="operation"
                    :item="cart.filter((x) => x.id == item.id)[0]"
                    :index="cart.findIndex((x) => x.id == item.id)"
                    :usage="'normal'"
                    v-else
                  />
                </div>
              </div>
              <!-- Product details -->
              <div
                class="product-details d-flex flex-column justify-space-between mt-1 pa-4 h-100"
              >
                <p class="mainFont--text text-right">{{ item.name }}</p>
                <div class="d-flex" v-if="item.discountedPrice">
                  <div
                    class="d-flex justify-center align-center text-center"
                    style="
                      border-radius: 50%;
                      background-color: #ef5350 !important ;
                      width: 24px;
                      height: 24px;
                      font-size: 10px;
                      margin-left: 12px;
                    "
                  >
                    <span class="white--text text-center"
                      >{{ item.discountPercentage }}%</span
                    >
                  </div>
                  <del class="red--text text-left fs-medium mb-0">
                    {{ Number(item.price).toLocaleString() }} تومان
                  </del>
                </div>
                <p
                  class="shopPrimary--text text-left fs-large mb-0"
                  v-if="item.discountedPrice"
                >
                  {{ Number(item.discountedPrice).toLocaleString() }} تومان
                </p>
                <p class="shopPrimary--text text-left fs-large mb-0" v-else>
                  {{ Number(item.price).toLocaleString() }} تومان
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapMutations } from "vuex";
import { HalfCircleSpinner, LoopingRhombusesSpinner } from "epic-spinners";
import ProductCounter from "./../../components/OnlineShop/ProductCounter";
import { EventBus } from "./../../event-bus.js";

export default {
  components: {
    ProductCounter,
    HalfCircleSpinner,
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      cart: [],
      addLoading: [],
      categoryProducts: [],
      categoryInfo: {},
      reactivity: false,
      pageLoading: false,
    };
  },

  mounted() {
    EventBus.$on("updateCategories", () => {
      this.getData();
    });
    this.getData();
  },

  methods: {
    ...mapMutations(["setInCart"]),
    setInStorage() {
      this.setInCart(this.cart);
      localStorage.setItem("cart", JSON.stringify(this.cart));
    },
    getData() {
      this.pageLoading = true;
      Axios.get(
        this.baseUrl + "/onlineShop/category/getData/" + this.$route.params.id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.categoryInfo = res.data;
            this.categoryProducts = res.data.items;
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.pageLoading = false;

          this.toast("Error: " + err.response.data, "error");
        });
      this.categoryProducts.forEach((x) => {
        this.addLoading.push(false);
      });
    },
    addToCart(item, index) {
      this.addLoading[index] = true;
      this.reactivity = !this.reactivity;
      setTimeout(() => {
        item.amount = 1;
        this.cart.push(item);
        this.setInStorage();
        this.addLoading[index] = false;
        this.reactivity = !this.reactivity;
      }, 1000);
    },
    isInCart(item) {
      let index = this.cart.findIndex((x) => x.id == item.id);
      if (index > -1) {
        return true;
      } else return false;
    },
  },

  computed: {
    ...mapGetters(["cartItems"]),
  },

  watch: {
    cartItems(val) {
      this.cart = val;
    },
  },
};
</script>

<style lang="scss">
.category-id {
  .products {
    .product-item {
      width: 100%;
      max-width: 240px;
      height: 380px;
      background-color: #fff;
      border-radius: 12px;
      .product-image {
        position: relative;
        img {
          width: 100%;
          border-radius: 12px 12px 0 0;
          aspect-ratio: 1 / 1;
        }
        .operation {
          position: absolute;
          bottom: 5px;
          right: 10px;
        }
        .add-btn {
          min-width: 0 !important;
          width: 35px;
          .v-icon {
            font-size: 1.2rem;
          }
        }
      }
    }
  }
}
</style>
